import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

const columns = [
  { field: "POH Name", label: "POH Name" },
  { field: "DirectLabour", label: "DIRECT LABOUR" },
  { field: "DirectStore", label: "DIRECT STORE" },
  { field: "OnCostLabour", label: "ON COST LABOUR" },
  { field: "OnCostStore", label: "ON COST STORE" },
  { field: "GrandTotal", label: "TOTAL" },
];


const parseAmount = (value) => {
  if (value == null) return 0;

  let str = String(value).replace(/,/g, "").trim();

  // Handle trailing minus
  if (str.endsWith("-")) {
    str = "-" + str.slice(0, -1);
  }

  return Number(str) || 0;
};


export default function WGRTable({
  rows,
  shop,
  totals,
  showTotal = true,
}) {
  return (
    <TableContainer>
      <Table
        size="small"
        stickyHeader
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                align="right"
                sx={{
                  fontWeight: 700,
                  bgcolor: "grey.200",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>




        </TableHead>

        <TableBody>
          {rows.map((row, index) => {
           
            return (
              <TableRow
                key={index}
                hover
                sx={{
                  "&:nth-of-type(even)": {
                    bgcolor: "grey.50",
                  },
                }}
              >
                <TableCell colSpan={1} align="left">{row["POH Name"]}</TableCell>

                <TableCell align="right">
                  <CurrencyCell value={row["DIRECT LEBOUR"]} />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell value={row["DIRECT STORE"]} />
                </TableCell>


                <TableCell align="right">
                  <CurrencyCell value={row["ON COST LABOUR"]} />
                </TableCell>


                <TableCell align="right">
                  <CurrencyCell value={row["ONCOST STORE"]} />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell value={row.GrandTotal} />
                </TableCell>


              </TableRow>



            );
          })}






          {showTotal && (
            <TableRow
              sx={{
                bgcolor: "primary.light",
                "& td": {
                  fontWeight: 700,
                  borderTop: "2px solid",
                  borderColor: "primary.main",
                },
              }}
            >
              <TableCell colSpan={1} align="right">
                Total Amount
              </TableCell>



              <TableCell align="right">
                <CurrencyCell value={totals.DirectLabour} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.DirectStore} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.OnCostLabour} />
              </TableCell>

               <TableCell align="right">
                <CurrencyCell value={totals.OnCostStore} />
              </TableCell>


               <TableCell align="right">
                <CurrencyCell value={totals.GrandTotal} />
              </TableCell>



            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}